import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { useParams } from "react-router-dom";
import { getAccionesDesarrolloPlantelThunk } from "../store/reducers/fortalezas/fortalezasPlantel.thunks";
import { resetFortalezasPlantel, clearAccionesError, setAccionesPage } from "../store/reducers/fortalezas/fortalezasPlantel.reducer";
import AccionesHeaderPlantel from "./fortalezas/fortalezas-plantel/AccionesHeaderPlantel";
import AccionesTablePlantel from "./fortalezas/fortalezas-plantel/AccionesTablePlantel";
import AccionViewModalPlantel from "./fortalezas/fortalezas-plantel/AccionViewModalPlantel";
import AccionFormModalPlantel from "./fortalezas/fortalezas-plantel/AccionFormModalPlantel";
import AccionMultiplesModalPlantel from "./fortalezas/fortalezas-plantel/AccionMultiplesModalPlantel";
import ConfirmToggleAccionModalPlantel from "./fortalezas/fortalezas-plantel/ConfirmToggleAccionModalPlantel";
import Loader from "./UI/Loader";
import Alert from "./UI/Alert";
import Pagination from "./UI/Pagination";
import EmptyState from "./UI/EmptyState";

const FortalezasAccionesListLayerPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { accionesList, accionesLoading, accionesError, accionesPage, accionesPageSize, accionesSearch, accionesFilterArea, accionesFilterTalento, accionesCount } = useSelector((state) => state.fortalezasPlantel);

  useEffect(() => {
    dispatch(getAccionesDesarrolloPlantelThunk({ plantelId, page: accionesPage, search: accionesSearch, area: accionesFilterArea, talento: accionesFilterTalento }));
  }, [dispatch, plantelId, accionesPage, accionesSearch, accionesFilterArea, accionesFilterTalento]);

  useEffect(() => () => { dispatch(resetFortalezasPlantel()); }, [dispatch]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <AccionesHeaderPlantel />
        {accionesError && <Alert message={accionesError} variant="error" onClose={() => dispatch(clearAccionesError())} />}
        {accionesLoading ? <Loader center text="Cargando acciones..." delay={200} /> : (
          <>
            {accionesSearch && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">{accionesCount > 0 ? <>Se {accionesCount === 1 ? "encontró" : "encontraron"} <strong className="text-primary">{accionesCount}</strong> {accionesCount === 1 ? "resultado" : "resultados"} para "{accionesSearch}"</> : <>No se encontraron resultados para "{accionesSearch}"</>}</span>
              </div>
            )}
            {accionesList.length === 0 ? <EmptyState icon={accionesSearch ? "mdi:magnify-remove-outline" : "mdi:lightbulb-outline"} title={accionesSearch ? "No se encontraron acciones" : "No hay acciones registradas"} description={accionesSearch ? "Intenta con otra búsqueda" : 'Haz clic en "Crear múltiples" para crear nuevas'} /> : (
              <>
                <AccionesTablePlantel acciones={accionesList} search={accionesSearch} />
                <Pagination page={accionesPage} count={accionesCount} pageSize={accionesPageSize} onPageChange={(p) => dispatch(setAccionesPage(p))} />
              </>
            )}
          </>
        )}
      </div>
      <AccionViewModalPlantel />
      <AccionFormModalPlantel />
      <AccionMultiplesModalPlantel />
      <ConfirmToggleAccionModalPlantel />
    </div>
  );
};

export default FortalezasAccionesListLayerPlantel;
